'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ellipsis;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // https://martinwolf.org/blog/2015/01/pure-css-savingloading-dots-animation


function Ellipsis(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('rrui__ellipsis', className),
    style: style
  }, _react2.default.createElement('div', {
    className: 'rrui__ellipsis__size'
  }, _react2.default.createElement('div', {
    className: 'rrui__ellipsis__dots'
  }, _react2.default.createElement('div', {
    className: 'rrui__ellipsis__dot rrui__ellipsis__dot--1'
  }), _react2.default.createElement('div', {
    className: 'rrui__ellipsis__dot rrui__ellipsis__dot--2'
  }), _react2.default.createElement('div', {
    className: 'rrui__ellipsis__dot rrui__ellipsis__dot--3'
  }))));
}